export default __webpack_public_path__ + "static/utk-logo-a63485b32f8a669e78dad62320fbbcc5.png";